import React from 'react'

export default function SeccionDias(props) {
    return (
        <>
            {props.children}
        </>
    )
}
